import { 
  ChartBarIcon, 
  DocumentTextIcon,
  TableCellsIcon,
  ListBulletIcon,
  ArrowRightIcon
} from '@heroicons/react/24/outline'
import { useTheme } from '../../context/ThemeContext'
import './styles.scss'

const features = [
  {
    name: 'Historical Data',
    description:
      'Access comprehensive historical market data through our REST API endpoints. Get price data for any timeframe from 1 minute to 1 month.',
    icon: ChartBarIcon,
  },
  {
    name: 'Technical Indicators',
    description:
      'Calculate and analyze technical indicators using our dedicated endpoints. Supports SMA, EMA, RSI, MACD, Bollinger Bands, and more.',
    icon: DocumentTextIcon,
  },
  {
    name: 'CSV Data',
    description:
      'Download market data in CSV format for easy analysis in spreadsheet software. Perfect for non-programmers and data analysts.',
    icon: TableCellsIcon,
  },
  {
    name: 'Ticker Information',
    description:
      'Get a list of available tickers filtered by type and exchange. Access detailed information about each trading instrument.',
    icon: ListBulletIcon,
  },
]

export const Features: React.FC = () => {
  const { isDarkMode } = useTheme();

  return (
    <div className={`relative py-24 sm:py-32 ${isDarkMode ? 'bg-gray-900' : 'bg-white'}`}>
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base font-semibold leading-7 text-accent-primary">API Features</h2>
          <p className={`mt-2 text-3xl font-bold tracking-tight sm:text-4xl ${isDarkMode ? 'text-gray-100' : 'text-gray-900'}`}>
            Market Data APIs
          </p>
          <p className={`mt-6 text-lg leading-8 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
            Access comprehensive market data through our well-documented REST APIs. Built for developers who need reliable, high-performance data for their applications.
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
            {features.map((feature) => (
              <div key={feature.name} className="flex flex-col">
                <dt className={`flex items-center gap-x-3 text-base font-semibold leading-7 ${isDarkMode ? 'text-gray-100' : 'text-gray-900'}`}>
                  <feature.icon className="h-5 w-5 flex-none text-accent-primary" aria-hidden="true" />
                  {feature.name}
                </dt>
                <dd className={`mt-4 flex flex-auto flex-col text-base leading-7 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                  <p className="flex-auto">{feature.description}</p>
                </dd>
              </div>
            ))}
          </dl>
        </div>
        
        {/* Documentation Button */}
        <div className="mt-16 flex justify-center">
          <a
            href="#/docs"
            className={`doc-button ${isDarkMode ? 'dark-mode' : 'light-mode'}`}
          >
            View Documentation
            <ArrowRightIcon className="ml-2 h-5 w-5" aria-hidden="true" />
          </a>
        </div>
      </div>
    </div>
  );
};
